import type { AdminCrewReportOwnerRepatriationBarRowProps } from "../../models/admin-crew-report.models";
import { getAdminCrewReportOwnerRepatriationAccessibleSummary } from "../../utils/admin-crew-report-statistics.utils";
import { ADMIN_CREW_REPORT_OWNER_REPATRIATION_SEGMENTS } from "../../utils/admin-crew-report.constants";
import AdminCrewReportOwnerRepatriationBarSegment from "./AdminCrewReportOwnerRepatriationBarSegment";

const AdminCrewReportOwnerRepatriationBarRow = ({
  owner,
  axisMaximum,
  axisTicks,
}: AdminCrewReportOwnerRepatriationBarRowProps) => (
  <div
    role="img"
    aria-label={getAdminCrewReportOwnerRepatriationAccessibleSummary(owner)}
    data-test="admin-crew-report-owner-repatriation-row"
    data-testid={`admin-crew-report-owner-repatriation-row-${owner.ownerName}`}
    className="grid min-h-8 grid-cols-[minmax(7rem,42%)_minmax(0,1fr)] items-center"
  >
    <span
      aria-hidden="true"
      title={owner.ownerName}
      className="truncate pr-2 text-right text-[10px] font-medium leading-3 text-[#24302E] dark:text-gray-200 sm:text-[11px]"
    >
      {owner.ownerName}
    </span>

    <div aria-hidden="true" className="relative h-5 min-w-0">
      {axisTicks.slice(1).map((tick) => (
        <span
          key={tick}
          data-testid={`admin-crew-report-owner-repatriation-gridline-${tick}`}
          className="pointer-events-none absolute inset-y-[-0.375rem] border-l border-dashed border-[#D8E6E3] dark:border-gray-600"
          style={{ left: `${(tick / axisMaximum) * 100}%` }}
        />
      ))}

      <div className="absolute inset-0 flex">
        {ADMIN_CREW_REPORT_OWNER_REPATRIATION_SEGMENTS.map((segment) => {
          const count = owner[segment.key];
          if (count <= 0) return null;

          return (
            <AdminCrewReportOwnerRepatriationBarSegment
              key={segment.key}
              axisMaximum={axisMaximum}
              count={count}
              ownerName={owner.ownerName}
              segment={segment}
            />
          );
        })}
      </div>
    </div>
  </div>
);

export default AdminCrewReportOwnerRepatriationBarRow;
